<template>
	<div class="itemWrapper">
		<div class="userInfor">
			<div class="avatarWrapper">
				<img :src="data.avatar" class="avatarImg img" />
			</div>
			<div class="userNameWrapper">
				<div class="userNameText">{{data.username}}</div>
				<div class="decorationText">关注了{{data.follow_username}}</div>
			</div>
			<div class="time"></div>
		</div>
		<div class="peopleWrapper">
			<div class="peopleAvatar">
				<img :src="data.follow_avatar" alt="">
			</div>
			<div class="rightArea">
				<div class="peopleDesc">
					<span class="peopleName">{{data.follow_username}}</span><span class="level"><img src="@/assets/image/personalCenter/blue_star.png">{{data.follow_level_name}}</span>
				</div>
				<div class="subTitle">{{data.follow_sightml}}</div>
			</div>
		</div>
		<div class="subItems">
			<div class="time">{{data.show_time}}</div>
			<div class="rightItems"></div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['data']
}
</script>

<style scoped>
.itemWrapper{
	padding: 10px 15px;
	margin-top: 5px;
	background-color: #fff;
}
.userInfor{
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
}
.avatarWrapper{
	width: 30px;
	height: 30px;
	overflow: hidden;
	border-radius: 15px;
	border-width: 1px;
	border-color: #fff;
}
.avatarImg{
	object-fit: cover;
}
.userNameWrapper{
	flex: 1;
	margin-left: 7px;
	margin-right: 7px;
}
.userNameText{
	font-size: 14px;
	color: #1d2023;
}
.decorationText{
	margin-top: 3px;
	font-size: 11px;
	color: #606972;
}

.peopleWrapper{
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
	padding: 10px;
	background-color: #fff8f4;
	border-radius: 6px;
	overflow: hidden;
}
.peopleAvatar{
	width: 50px;
	height: 50px;
	margin-right: 10px;
	flex-shrink: 0;
	border-radius: 50%;
	background-color: #f7f8f8;
	overflow: hidden;
}
.peopleAvatar > img{
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.peopleWrapper .rightArea{
	flex: 1;
}

.peopleDesc > .peopleName{
	font-size: 16px;
	color: #1d2023;
	font-weight: 600;
}
.peopleDesc > .level{
	margin-left: 8px;
	padding: 3px 5px;
	font-size: 9px;
	color: #2086fc;
	background-color: #e2effe;
	border-radius: 2px;
}
.level > img{
	width: 10px;
	height: 10px;
	margin-right: 2px;
}
.subTitle{
	font-size: 14px;
	color: #606972;
}



.subItems{
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}
.leftItems{
	display: flex;
	flex-direction: row;
}
.subitem{
	padding-left: 4px;
	padding-right: 4px;
	font-size: 10px;
	color: #e60020;
	background-color: #fae7e7;
	border-radius: 2px;
}
.time{
	font-size: 12px;
	color: #606972;
}


.iconTop{
	width: 10px;
	height: 10px;
}
.hidden{
	display: none;
	width: 0;
	height: 0;
}
.img{
	width: 100%;
	height: 100%;
}
</style>